// Module
var code = "<abm-list-item ng-click=\"vm.goToDetails()\"> <p class=\"abm-mobile-list-item-title\" ng-bind=\"vm.building.name\"></p> </abm-list-item> ";
// Exports
module.exports = code;